// extracted by mini-css-extract-plugin
export default {"aboutContainer":"About_aboutContainer__Z17NL","sectionContainer":"About_sectionContainer__dJFvp"};